import update from 'immutability-helper';
import DeviceController from '../models/device/deviceController';
import { DEVICE } from '../actions/device';

const initialState = {
  all: {},
  device: {},
  loading: false,
  fetchSuccess: null,
  registerSuccess: null
};

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case DEVICE.FETCH_ALL: {
      return { ...state, loading: true, fetchSuccess: true };
    }
    case DEVICE.RE_FETCH_ALL: {
      return { ...state, loading: false, fetchSuccess: true };
    }
    case DEVICE.FETCH_ALL_FAILED: {
      return { ...state, loading: false, fetchSuccess: false};
    }
    case DEVICE.FETCH_BY_USER_ID_FAILED: {
      return { ...state, loading: false, fetchSuccess: false};
    }
    case DEVICE.SET_ALL: {
      const all = action.payload.data;
      return { ...state, all, loading: false, fetchSuccess: true };
    }
    case DEVICE.SET_REGISTERED: {
      const inputDevice = action.payload.data;
      const deviceId = inputDevice.id;
      const all = { ...state.all, [deviceId]: DeviceController.cloneDeep(inputDevice)};
      return {...state, all: all, loading: false, fetchSuccess: true};
    }
    case DEVICE.SET: {
      const inputDevice = action.payload.data;
      const deviceId = inputDevice.id;
      return update(state, {
        device: {
          [deviceId]: {
            $set: DeviceController.cloneDeep(inputDevice),
          }
        },
        all: {
          [deviceId]: {
            $set: DeviceController.cloneDeep(inputDevice),
          }
        }
      })
    }
    default: {
      return state;
    }
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/device.js